<template>
    <b-container id="Portfolio">
        <!-- Title -->
        <h1 class="title masthead-heading" >Portfolio</h1>
        <hr class="my-4" />

        <!-- List of projects -->
        <b-card-group columns>
            <!-- Go through every Projects--> 
            <PortfolioCard v-for="(project, index) in this.projects" :key="index" 
                           :projectTitle="project.title" 
                           :id="project.id"
                           :url="project.url"
                           :image="project.image"
                           :pictures="project.pictures"
                           :description="project.description"  />
            

        </b-card-group>
        
    </b-container>
</template>
<script>
import PortfolioCard from '../components/PortfolioCard.vue';
export default {
    components: {
        PortfolioCard,
    },
    data: function (){
        return {
            projects: {
                wikeasy: {
                    id: 'wikeasy',
                    title: 'Wikeasy',
                    description: "Wikeasy is a **smartphone app** to get quick information from a research. ## Specification of the project",
                    pictures: [
                        '/img/wikeasy/WikeasyScreen1.png',
                        '/img/wikeasy/WikeasyScreen2.PNG',
                        '/img/wikeasy/WikeasyScreen3.PNG',
                        '/img/wikeasy/WikeasyScreen4.PNG',
                        // '/img/wikeasy/WikeasyScreen.gif',
                    ],
                    image: 'https://repository-images.githubusercontent.com/223611243/6185ad00-c6cc-11ea-9ffb-6bb76b510885',
                    url: '',
                    imgWidth: "50px",
                    isMobileApp: true
                },
                
                custard: {
                    id: 'Custard',
                    title: 'Custard Api',
                    pictures: [
                    ],
                    description: `Custard is a .NET Standard library allowing to make API method calls easily. 😁`,
                    image: 'https://user-images.githubusercontent.com/37577669/85275198-47b3ca00-b480-11ea-8273-d990295416a7.png',
                    url: 'https://github.com/bricefriha/CustardApi',
                    isMobileApp: false
                },
                
                TodoKernelApi: {
                    id: 'TodoKernel Api',
                    title: 'TodoKernel',
                    pictures: [
                    ],
                    description: `You want to create a todolist app without bothering too much with a backend code. Here's how TodoKernel can help you! 😃 
                    TodoKernel is an API ready to go allowing you to create todolists. Then all you have to do is to create a sweat little UI that fit your need! 😊 ("have to do", "todo" you get the pun? 😅)`,
                    
                    url: 'https://github.com/bricefriha/TodoKernel',
                    isMobileApp: false
                },
                TodoKernelWeb: {
                    id: 'TodoKernel WebApp',
                    title: 'TodoKernel WebApp',
                    pictures: [
                        "/img/todoKernelWebApp/dashboard.PNG",
                        "/img/todoKernelWebApp/login.PNG"
                    ],
                    description: "This is a todo webapp using TodoKernel as backend 😁 This is a way for me to test TodoKernel API in a vuejs App",
                    url: 'https://github.com/bricefriha/TodoKernel_webapp_sample',
                    picPadding: "100%"
                },

            }
        }
    }
}
</script>
<style scoped>
    /* .container {
        margin: auto !important;
        
        
    } */
    .card-columns {
        display: flex !important;
        flex-flow: row wrap !important;
        margin: auto !important;
    }
    .title {
        
        color: #1a1a1a;
    }
</style>